export default __webpack_public_path__ + "static/media/455-Series-Regulators.e9ad30d5.jpg";